import _ from 'lodash';
import { connect } from 'react-redux';
import { search, test, remove } from '../modules/notificationJob';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {
	let notificationJobs = [];
	if (state.lists.notificationJobIds) {
		notificationJobs = _.map(state.lists.notificationJobIds,
			id => state.maps.notificationJob[id]
		);
	}
	return {
		notificationJobs,
		stationMap : state.maps.station,
		userMap : state.maps.user,
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	search,
	removeNotificationJob : remove,
	testNotificationJob : test
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
